@if (!isAdminCreatingUser && !isAdminEditingUsers && !isAdminEditingAreas) {
<div id="editFeatureOptions">
  @if (editFeatureService.userAreas$ | async; as userAreas) {
  @if (userAccess < UserAccess.Admin && userAccess > UserAccess.Read && userAreas?.length > 1 &&
    editFeatureService.defaultUserArea) {
    <mat-form-field appearance="outline" class="createFeatureBtn">
      <mat-label>{{selText.area}}</mat-label>
      <mat-select [value]="editFeatureService.defaultUserArea.id" (selectionChange)="onAreaSelectionChange($event)"
        [ngClass]="{'selected-area': editFeatureService.defaultUserArea}">
        @for (area of userAreas; track area) {
        <mat-option [value]="area.id">
          {{ area.name }}
        </mat-option>
        }
      </mat-select>
    </mat-form-field>
    }
    }
    @if (allowCreate && allowedGeoTypes.length === 1 && userAccess >= UserAccess.Update &&
    !displayService.disableFeatureClick && !editFeatureService.isDrawingFeature && !isAdminCreatingRestrictedArea &&
    !editFeatureService.showStationOpen && (editFeatureService.selectInteraction?.getFeatures()?.getLength() ?? 0) === 0) {
    <button class="createFeatureBtn" mat-raised-button color="primary" (click)="drawNewFeature(allowedGeoTypes[0].Type)">
      {{selText.new}}
    </button>
    }
    @if (allowCreate && allowedGeoTypes.length > 1 && userAccess >= UserAccess.Update &&
    !displayService.disableFeatureClick
    && !editFeatureService.isDrawingFeature && !isAdminCreatingRestrictedArea && !editFeatureService.showStationOpen
    && (editFeatureService.selectInteraction?.getFeatures()?.getLength() ?? 0) === 0) {
    <button mat-raised-button color="primary" [matMenuTriggerFor]="feature" class="createFeatureBtn">
      {{selText.new}}
    </button>
    }
    @if (editFeatureService.isDrawingFeature) {
    <button mat-raised-button color="warn" (click)="cancelNewFeature()" class="createFeatureBtn">
      {{selText.quit}}
    </button>
    }
    @if (snapOnItems && (editFeatureService.isDrawingFeature ||
    this.displayService.editFeatureActiveInActionView$.getValue() === true))
    {
    <button mat-raised-button color="link" (click)="toggleSnapInteraction()" class="createFeatureBtn"
      matTooltipClass="tooltipStyle" [matTooltip]="editFeatureService.getSnapTurnedOn()
                          ? selText.snapOffInstructions
                          : selText.snapOnInstructions">
      {{ editFeatureService.getSnapTurnedOn() ? selText.snapOff : selText.snapOn }}
    </button>
    @if (
    editFeatureService.currentLayer &&
    editFeatureService.currentLayer.option?.mp_layer?.edit?.geometry?.type !== 'Point' &&
    editFeatureService.currentLayer.option?.mp_layer?.edit?.geometry?.type !== 'MultiPoint')
    {
    <button mat-raised-button color="link" (click)="editFeatureService.toggleInteraction()" class="createFeatureBtn"
      matTooltipClass="tooltipStyle" [matTooltip]="editFeatureService.modifyInteraction?.getActive()
                            ? selText.moveRecordInstructions
                            : selText.editRecordInstructions">
      {{ editFeatureService.modifyInteraction?.getActive() ? selText.moveRecord : selText.editRecord }}
    </button>
    }
    @else if (
    editFeatureService.eventNewFeature &&
    editFeatureService.eventNewFeature.getGeometry()?.getType() !== 'Point' &&
    editFeatureService.eventNewFeature.getGeometry()?.getType() !== 'MultiPoint') {
    <button mat-raised-button color="link" (click)="editFeatureService.toggleDrawInteraction()" class="createFeatureBtn"
      matTooltipClass="tooltipStyle" [matTooltip]="editFeatureService.drawModifyInteraction?.getActive()
                            ? selText.moveRecordInstructions
                            : selText.editRecordInstructions">
      {{ editFeatureService.drawModifyInteraction?.getActive() ? selText.moveRecord : selText.editRecord }}
    </button>
    }
    }
    @if (allowCreate && haveRestrictedArea && userAccess >= UserAccess.Admin && !displayService.disableFeatureClick &&
    !editFeatureService.isDrawingFeature && !isAdminCreatingRestrictedArea && !editFeatureService.showStationOpen
    && (editFeatureService.selectInteraction?.getFeatures()?.getLength() ?? 0) === 0) {
    <button mat-raised-button color="primary" [matMenuTriggerFor]="editFeature"
      class="createFeatureBtn">{{selText.admin}}</button>
    }
    @if(haveDragAndDropFeatures){
    <button mat-raised-button color="primary" matTooltipClass="tooltipStyle"
      matTooltip="{{selText.clearDragAndDropDescription}}"
      (click)="clearDragAndDropFeatures()"
      class="createFeatureBtn">
      {{selText.clearMeasure}}
    </button>
    @if(applicationSettings?.option?.edit?.restrictedArea && userAccess < UserAccess.Admin &&
      (editFeatureService.selectInteraction?.getFeatures()?.getLength() ?? 0) === 0 && (editFeatureService.featureType==='LineString' ||
      editFeatureService.featureType==='MultiLineString' )) { <button mat-raised-button color="link"
      matTooltip="{{selText.cutDescription}}" (click)="cutFeature()">
      {{ selText.cut }}
      </button>
      }
      }
      <mat-menu #feature="matMenu">
        <ng-container *ngFor="let geoType of allowedGeoTypes">
          @if (geoType.Type === 'MultiPoint') {
          <button mat-menu-item (click)="drawNewFeature('MultiPoint', geoType?.SubType?.Layer)">
            {{ geoType.SubType?.Label || selText.point }}
          </button>
          }
          @if (geoType.Type === 'Point') {
          <button mat-menu-item (click)="drawNewFeature('Point', geoType?.SubType?.Layer)">
            {{ geoType.SubType?.Label || selText.point }}
          </button>
          }
          @if (geoType.Type === 'MultiLineString') {
          <button mat-menu-item (click)="drawNewFeature('MultiLineString', geoType?.SubType?.Layer)">
            {{ geoType.SubType?.Label || selText.line }}
          </button>
          }
          @if (geoType.Type === 'LineString') {
          <button mat-menu-item (click)="drawNewFeature('LineString', geoType?.SubType?.Layer)">
            {{ geoType.SubType?.Label || selText.line }}
          </button>
          }
          @if (geoType.Type === 'MultiPolygon') {
          <button mat-menu-item (click)="drawNewFeature('MultiPolygon', geoType?.SubType?.Layer)">
            {{ geoType.SubType?.Label || selText.polygon }}
          </button>
          }
        </ng-container>
      </mat-menu>
      <mat-menu #editFeature="matMenu">
        @if (userAccess >= UserAccess.Admin && !displayService.getEditFeatureActive().getValue()) {
        <button mat-menu-item (click)="addNewUser()">{{selText.newUser}}</button>
        }
        <button mat-menu-item (click)="listUsers()">{{selText.alterUser}}</button>
        <hr>
        <mat-menu #restrictedAreaMenu="matMenu">
          <button mat-menu-item (click)="drawNewRestrictedArea(false)">{{selText.polygon}}</button>
          <button mat-menu-item (click)="drawNewRestrictedArea(true)">{{selText.rectangle}}</button>
        </mat-menu>
        @if (userAccess >= UserAccess.Admin && !displayService.getEditFeatureActive().getValue()) {
        <button mat-menu-item [matMenuTriggerFor]="restrictedAreaMenu">{{selText.newArea}}</button>
        }
        <button mat-menu-item (click)="onAlterAreaClick()">{{selText.alterArea}}</button>
      </mat-menu>
      @if (isAdminCreatingRestrictedArea) {
      <input id="areaName" type="text" [(ngModel)]="restrictedAreaName" [placeholder]="selText.nameLabelText"
        (click)="$event.stopPropagation()">
      }
      @if (isAdminCreatingRestrictedArea) {
      <button mat-raised-button color="primary" (click)="createNewRestrictedArea()" class="createFeatureBtn"
        [disabled]="!restrictedAreaName || (editFeatureService.isDrawingRestrictedArea$ | async)">
        {{selText.submit}}
      </button>
      }
      @if (isAdminCreatingRestrictedArea) {
      <button mat-raised-button color="warn" (click)="cancelNewRestrictedArea($event)" class="createFeatureBtn">
        {{selText.quit}}
      </button>
      }
      @if (allowFilter && !isAdminCreatingRestrictedArea && !displayService.disableFeatureClick && userAccess >
      UserAccess.Read && !editFeatureService.isDrawingFeature &&
      (editFeatureService.selectInteraction?.getFeatures()?.getLength() ?? 0) === 0) {
      <mat-slide-toggle [(ngModel)]="editFeatureService.isFilterTextBoxVisible"
        [matTooltip]="editFeatureService.isFilterTextBoxVisible ? selText.turn_off_filter : selText.turn_on_filter"
        (change)="onSlideToggleChange()">
      </mat-slide-toggle>
      }
      @if (allowFilter && !isAdminCreatingRestrictedArea && !displayService.disableFeatureClick && userAccess >
      UserAccess.Read && !editFeatureService.isDrawingFeature) {
      <div>
        @if (editFeatureService.isFilterTextBoxVisible) {
        <mat-select id="userSelectList" [(ngModel)]="editFeatureService.filterText" (selectionChange)="onSlideToggleChange()">
          @for (user of sortedUsers; track user) {
          <mat-option [value]="user.username">
            {{ user.userUpdate.origin === 'local' ? user.username : (user.userUpdate.origin ? user.userUpdate.name :
            user.username) }}
          </mat-option>
          }
        </mat-select>
        }
        </div>
      }
</div>
}

@if (isAdminCreatingUser) {
<div id="createUserOptions">
  <form (click)="$event.stopPropagation()" [formGroup]="userForm!">
    <div class="user">
      @for (field of sortedFields; track field) {
      @if (!field.hide) {
      @switch (field.type) {
      @case (FieldTypes.Dropdown) {
      <mat-form-field appearance="outline" class="formField" floatLabel="always">
        <mat-label [attr.for]="field.name">
          {{ field.title }}
          @if (userForm?.get(field.name)?.dirty && userForm?.get(field.name)?.valid) {
          <span>
            <mat-icon>cached</mat-icon>
          </span>
          }
        </mat-label>
        <mat-select [id]="field.name" [formControlName]="field.name">
          @for (obj of field.optionsObj; track obj) {
          @if (!obj?.superAdminOnly || userAccess > UserAccess.Admin) {
          <mat-option [value]="obj.value">
            {{ obj.displayText }}
          </mat-option>
          }
          }
        </mat-select>
      </mat-form-field>
      }
      @case (FieldTypes.AreasKeyValueDropdown) {
      <mat-form-field appearance="outline" class="formField" floatLabel="always">
        <mat-label [attr.for]="field.name">
          {{ field.title }}
          @if (userForm?.get(field.name)?.dirty && userForm?.get(field.name)?.valid) {
          <span>
            <mat-icon>cached</mat-icon>
          </span>
          }
        </mat-label>
        <input type="text" matInput [placeholder]="selText.search" (keyup)="filterAreas($event)">
        <mat-select [id]="field.name" [formControlName]="field.name">
          @for (area of (areaSearchTerm.trim() === '' ? editFeatureService.allAreas$.getValue() : filteredAreas); track
          area) {
          <mat-option [value]="area.id" (click)="showAreaDetails(area)">{{ area.combined }}</mat-option>
          }
          </mat-select>
          </mat-form-field>
          }
          @case (FieldTypes.OtherAreasKeyValueDropdown) {
          <mat-form-field appearance="outline" class="formField" floatLabel="always">
            <mat-label [attr.for]="field.name">
              {{ field.title }}
              @if (userForm?.get(field.name)?.dirty && userForm?.get(field.name)?.valid) {
              <span>
                <mat-icon>cached</mat-icon>
              </span>
              }
            </mat-label>
            <mat-select [id]="field.name" [formControlName]="field.name" multiple>
              @for (area of editFeatureService.allAreas$ | async; track area) {
          <mat-option [value]="area.id" (click)="showAreaDetails(area)">{{ area.combined }}</mat-option>
          }
          </mat-select>
          </mat-form-field>
          }
          @case (FieldTypes.Password) {
          <mat-form-field appearance="outline" class="formField" floatLabel="always">
            <mat-label [attr.for]="field.name">
              {{ field.title }}
              @if (userForm?.get(field.name)?.dirty && userForm?.get(field.name)?.valid) {
              <span>
                <mat-icon>cached</mat-icon>
              </span>
              }
            </mat-label>
            <input matInput [formControlName]="field.name" [type]="passwordFieldType" autocomplete="new-password">
            <button mat-icon-button matSuffix (click)="togglePasswordVisibility(false)"
              [attr.aria-label]="passwordFieldType === 'password' ? selText.showPassword : selText.hidePassword"
              matTooltip="{{ passwordFieldType === 'password' ? selText.showPassword : selText.hidePassword }}">
              <mat-icon>{{ passwordFieldType === 'text' ? 'visibility_off' : 'visibility' }}</mat-icon>
            </button>
          </mat-form-field>
          }
          @default {
          <mat-form-field appearance="outline" class="formField" floatLabel="always">
            <mat-label [attr.for]="field.name">
              {{ field.title }}
              @if (userForm?.get(field.name)?.dirty && userForm?.get(field.name)?.valid) {
              <span>
                <mat-icon>cached</mat-icon>
              </span>
              }
            </mat-label>
            <input matInput [formControlName]="field.name">
          </mat-form-field>
          }
          }
          }
          }
          </div>
          </form>
          <div class="button-container">
            <button mat-raised-button color="primary" [disabled]="userForm?.pristine || !userForm?.valid" (click)="saveUser()">
              {{ selText.submit }}
            </button>
            <button mat-raised-button color="warn" (click)="cancelUser()">
              {{ selText.quit }}
            </button>
          </div>
          </div>
          }

@if (isAdminEditingAreas || isAdminEditingUsers) {
<button id="closeEditBtn" class="closeBtn" (click)="cancelList(false, true)"><mat-icon>close</mat-icon></button>
}

@if (isAdminEditingUsers) {
<div class="editItemOptions" (click)="$event.stopPropagation()" (input)="hasUserChanged = true">
  <div class="changeListContainer">
    <mat-slide-toggle [matTooltip]="isFilteringUsers ? selText.turn_off_filter : selText.showActiveUsers"
      (change)="isFilteringUsers = !isFilteringUsers">
    </mat-slide-toggle>
    @if (isFilteringUsers) {
    <ul>
      @for (user of sortedUsers; track user.id) {
      <li (click)="showUserDetails(user)" class="pointerCursor">
        {{ user.userUpdate.origin === 'local' ? user.username : (user.userUpdate.origin ? user.userUpdate.name :
        user.username) }}
      </li>
      }
    </ul>
    }
    @if (!isFilteringUsers) {
    <ul>
      @for (user of sortedNonFilteredUsers; track user) {
      <li (click)="showUserDetails(user)" class="pointerCursor">
        {{ user.userUpdate.origin === 'local' ? user.username : (user.userUpdate.origin ? user.userUpdate.name :
        user.username) }}
      </li>
      }
    </ul>
    }
  </div>
  @if (selectedUser) {
  <div id="editSelectedUser">
    <h6><strong>{{ getFieldTitle('id') }}:</strong> {{ selectedUser.id }}</h6>
    <h6><strong>{{ getFieldTitle('username') }}:</strong> {{ selectedUser.username }}</h6>
    <div>
      <label for="name"><strong>{{ getFieldTitle('fullName') }}:</strong></label><br>
      <input type="text" id="name" name="name" [(ngModel)]="selectedUser.userUpdate.name">
    </div>
    <div>
      <label for="email"><strong>{{ getFieldTitle('email') }}:</strong></label><br>
      <input type="text" id="email" name="email" [(ngModel)]="selectedUser.userUpdate.email" autocomplete="off">
    </div>
    <div>
      <label for="password"><strong>{{ selText.newPassword }}:</strong></label><br>
      <input matInput [type]="newPasswordFieldType" id="password" name="password"
        [(ngModel)]="selectedUser.userUpdate.password" autocomplete="new-password">
      <button type="button" id="toggle-password-visibility" (click)="togglePasswordVisibility(true)">
        <mat-icon>{{ newPasswordFieldType === 'password' ? 'visibility' : 'visibility_off' }}</mat-icon>
      </button>
    </div>
    <div>
      <label for="confirmPassword"><strong>{{ selText.validatePassword }}:</strong></label><br>
      <input matInput [type]="newPasswordFieldType" id="confirmPassword" name="confirmPassword"
        [(ngModel)]="selectedUser.userUpdate.confirmPassword" autocomplete="new-password">
    </div>
    <div>
      <h6><strong>{{ selText.userAccess }}:</strong></h6>
      @for (group of selectedUser.groups; track group.id) {
      <div class="groupItem">
        <input type="radio" name="userGroup" [checked]="group.selected" (change)="onGroupRadioChange(group)"
          [disabled]="disableUsersGroupCheckbox(group)">
        {{ group.name }}
      </div>
      }
      </div>
      <div>
        <label for="defaultArea"><strong>{{ selText.area }}:</strong></label><br>
        <mat-form-field appearance="fill">
          <mat-select id="defaultArea" name="defaultArea" [(ngModel)]="selectedUser.defaultArea"
            (ngModelChange)="hasUserChanged = true">
            @for (area of editFeatureService.allAreas$ | async; track area) {
          <mat-option [value]="area.id" (click)="showAreaDetails(area)">
            {{ area.combined }}
          </mat-option>
          }
          </mat-select>
          </mat-form-field>
          </div>
          <div id="editSelectedUserBtn">
            <button mat-raised-button color="primary" (click)="saveUserChanges(selectedUser)" [disabled]="!hasUserChanged">
              {{ selText.submit }}
            </button>
            <button mat-raised-button color="warn" (click)="cancelList(true, false)">
              {{ selText.quit }}
            </button>
          </div>
          </div>
          }
          @if (selectedUser) {
          <div>
            <strong>{{ selText.otherAreas }}:</strong>
            <div class="changeListContainer">
              @for (area of editFeatureService.allAreas$ | async; track area) {
              <div>
                <input type="checkbox" name="areas" [value]="area.id" [checked]="selectedUser.otherAreas?.includes(area.id)"
                  (change)="onAreaChange($event, area.id)">
                <span class="clickableArea" (click)="showAreaDetails(area)">{{ area.combined }}</span>
              </div>
              }
            </div>
          </div>
          }
          </div>
          }

@if (isAdminEditingAreas) {
<div class="editItemOptions">
  <div>
    <ul>
      @for (area of editFeatureService.allAreas$ | async; track area) {
      <li (click)="showAreaDetailsWithInteractions(area)" class="pointerCursor">
        <div class="areaWrapper">
          <span>{{ area.combined }}</span>
          @if (selectedArea && area.id === selectedArea.id) {
          <div id="changeAreaBtnWrapper" class="buttonContainer">
            <input type="text" [value]="newAreaName" placeholder="{{selText.newAreaNamePlaceholder}}"
              (input)="onRestrictedAreaNameChange($any($event.target).value)" (click)="$event.stopPropagation()">
            <div>
              <button matTooltip="{{ selText.rotate }}" class="closeBtn"
                (click)="rotateArea($event, selectedArea, true)"><mat-icon>rotate_left</mat-icon></button>
              <button matTooltip="{{ selText.rotate }}" class="closeBtn"
                (click)="rotateArea($event, selectedArea, false)"><mat-icon>rotate_right</mat-icon></button>
              <button matTooltip="{{ selText.expand }}" class="closeBtn"
                (click)="resizeArea($event, selectedArea, true)"><mat-icon>add</mat-icon></button>
              <button matTooltip="{{ selText.decrease }}" class="closeBtn"
                (click)="resizeArea($event, selectedArea, false)"><mat-icon>remove</mat-icon></button>
            </div>
            <button class="areaButton" mat-raised-button color="primary" (click)="updateArea($event, selectedArea)"
              [disabled]="!hasAreaChanged">
              {{ selText.submit }}
            </button>
          </div>
          }
        </div>
      </li>
      }
      </ul>
      </div>
      </div>
      }